import { render, staticRenderFns } from "./CreateBannerForm.vue?vue&type=template&id=d4a6074a&"
import script from "./CreateBannerForm.vue?vue&type=script&lang=js&"
export * from "./CreateBannerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports